import React, { useEffect, useState } from "react";
import { LoadingButton } from "@mui/lab";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import { Typography, Grid, Button, MenuItem } from "@mui/material";

import { useAlert } from "../../../../hooks";
import useAxios from "./../../../../hooks/useAxios";
import TextField from "./../../../../components/TextField";

const SubHeading = styled(Typography)`
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 30px;
  color: #000000;
`;

const CancelButton = styled(Button)`
  border: 1px solid #bdbdbd;
  border-radius: 30px;
  font-weight: 600;
  font-size: 18px;
  line-height: 27px;
  text-align: center;
  color: #bdbdbd;
  padding: 10px 16px;
  margin-right: 10px;
  height: 50px;
  width: 180px;
  &:hover {
    border: 1px solid #bdbdbd;
  }
`;

const PrimaryButton = styled(LoadingButton)`
  border-radius: 30px;
  font-weight: 600;
  font-size: 18px;
  line-height: 27px;
  text-align: center;
  padding: 10px 16px;
  height: 50px;
  width: 180px;
`;

export default function FormDisplay({
  formikProps,
  changeCampaignStatusDialog,
  handleClose,
}) {
  const axios = useAxios();
  const { alert } = useAlert();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [dropDownValue, setDropDownValue] = useState("");
  const [campaignStatus, setCampaignStatus] = useState([]);

  useEffect(() => {
    if (changeCampaignStatusDialog) {
      axios({ url: "/campaign/CampaignStatus", disableRedirect: true }).then(
        (response) => {
          if (response.status) {
            setCampaignStatus(response.data);
          }
        }
      );
    }
  }, []);

  return (
    <React.Fragment>
      <Grid size={12}>
        <SubHeading>Change campaign status</SubHeading>
      </Grid>

      <Grid size={12}>
        <TextField
          select
          label="Select Value"
          placeholder="Select Value"
          onChange={(e) => setDropDownValue(e.target.value)}
          value={dropDownValue}
        >
          {campaignStatus.map((item, index) => {
            return (
              <MenuItem key={index} value={item}>
                {item}
              </MenuItem>
            );
          })}
        </TextField>
      </Grid>

      <Grid size={12} />

      <Grid size />

      <Grid item>
        <CancelButton variant="outlined" onClick={handleClose}>
          Cancel
        </CancelButton>
      </Grid>

      <Grid item>
        <PrimaryButton
          type="submit"
          variant="contained"
          onClick={handleCampaignStatus}
          loading={loading}
          disabled={!dropDownValue}
        >
          Submit
        </PrimaryButton>
      </Grid>
    </React.Fragment>
  );

  function handleCampaignStatus() {
    setLoading(true);
    axios({
      url: "/campaign/changeStatus",
      method: "POST",
      data: {
        campaign_id: formikProps.values.campaignID,
        status: dropDownValue,
      },
    }).then((response) => {
      if (response.status) {
        formikProps.setValues((prev) => ({
          ...prev,
          statusApproval: "MANUAL",
        }));

        dispatch(
          alert({
            type: "success",
            message: "Status Change Successfully",
          })
        );

        handleClose();
      }

      setLoading(false);
    });
  }
}
